import PropTypes from 'prop-types';
import { createContext, useContext, useMemo, useState } from 'react';

const OrderPerformanceRulesRematchHoldContext = createContext({
	rematchRenderHold: false,
	setRematchRenderHold: () => {},
});

export const useOrderPerformanceRulesRematchHold = () => useContext(OrderPerformanceRulesRematchHoldContext);

const OrderPerformanceRulesRematchHoldProvider = ({ children }) => {
	const [rematchRenderHold, setRematchRenderHold] = useState(false);
	const value = useMemo(() => ({ rematchRenderHold, setRematchRenderHold }), [rematchRenderHold]);

	return <OrderPerformanceRulesRematchHoldContext.Provider value={value}>{children}</OrderPerformanceRulesRematchHoldContext.Provider>;
};

OrderPerformanceRulesRematchHoldProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default OrderPerformanceRulesRematchHoldProvider;
